import 'vue-multiselect/dist/vue-multiselect.min.css';

import VeeValidate from 'vee-validate';

import CardHeader from "@/components/Includes/CardHeader/CardHeader.vue";
import IClientApp from "@/interfaces/IClientApp";
import IPayloadQuery from "@/interfaces/IPayloadQuery";
import capitalizeFirstLetter from "@/libs/capitalizeFirstLetter";
import Multiselect from 'vue-multiselect';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

import IMultiSelectItem from '@/interfaces/selects/IMultiSelectItem';
import {Switch as cSwitch} from '@coreui/vue';
import {Action, Getter} from "vuex-class";

import cloneObject from "@/libs/cloneObject";
import isEmpty from "@/libs/isEmpty";
import {transformMultiSelect} from "@/libs/transformData/transformMultiSelect";


Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: 'veeFields'
});


@Component({
    components: {
        Multiselect,
        CardHeader,
        cSwitch
    }
})
export default class ClientAppForm extends Vue {
    @Prop(Object) private formData!: IClientApp;
    @Prop(Boolean) private loading!: boolean;
    @Prop(Boolean) private isCreateForm!: boolean;

    @Action private vpnsList!: (query: IPayloadQuery) => number;
    @Getter private getVPNs!: () => any[];

    private vpns: IMultiSelectItem[] = [];
    private form = '';

    private get isSubscriptions() {
        return this.$route.name === 'subscriptions_client_apps_list';
    }

    @Watch('formData')
    private reformatVpns() {
        if (this.formData) {
            const form = cloneObject(this.formData);
            if (Array.isArray(form.vpnServers)) {
                form.vpnServers = this.vpns.filter((vpn: IMultiSelectItem) => form.vpnServers.includes(Number(vpn.value)));
            }
            this.form = form;
        }
    };

    // Begin Handler by Form
    private checkRequired(field: string): string {
        const requiredFields = [
            'title',
            'name',
            'secret',
            'email',
            'isCampaignDriven',
            'deviceTypeId',
            'diKey',
            'email',
            'secret',
            'title',
        ];

        return field === 'email' ? 'required|email' : (requiredFields.indexOf(field) !== -1 ? 'required' : 'min:1');
    }


    private invalidValue(fieldName: string) {
        return this.$validator.errors.has(fieldName);
    }

    private handleSave() {
        this.validateForm();
    }

    private validateForm() {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.$emit('respClientApp', this.form);
            }
        });
    }

    // End Handler by Form

    private transformValue(value: any): string {
        return value ? String(value) : '–';
    }

    private transformLabel(field: string): string {
        return capitalizeFirstLetter(field);
    }

    private hideFields(field: string): boolean {
        const fields = [
            'createdAt',
            'updatedAt',
            'id',
        ];
        return fields.includes(field);
    }

    private setLoadedVpns() {
        this.vpns = transformMultiSelect(this.getVPNs(), 'host', 'id');
    }

    private async loadVpns(): Promise<void> {
        try {
            if (isEmpty(this.getVPNs())) {
                await this.vpnsList({query: '?pagination=false'});
                this.setLoadedVpns();
            } else {
                this.setLoadedVpns();
            }
        } catch (error) {
            throw new Error(error)
        }
    }

    private async mounted() {
        if (!this.isSubscriptions) {
            await this.loadVpns();
        }

        if (!this.isCreateForm) {
            this.reformatVpns()
        } else {
            this.form = cloneObject(this.formData);
        }
    }
}
